import { BlockTitle } from "@blocks/Blocks";

/**
 * Component to render E50 awards page
 */
const E50AwardsPage = (): React.ReactElement => {
  return (
    <div
      className="mb-6 font-public-sans"
      data-testid="E50-awards-page-component"
    >
      <BlockTitle
        text="Awards"
        rootClassName="py-3 text-4xl md:text-6xl lg:text-8xl font-medium mb-3"
      />

      <p>
        <strong>Ranking System</strong>
      </p>

      <p>
        Ranking of the top fifty companies will be primarily based on the
        weighted-average computation of a set of performance indicators over a
        three-year period. These indicators include:
      </p>

      <ul className="mb-4 list-outside list-disc pl-8">
        <li>Operating Profit Before Tax (OPBT)</li>
        <li>Gross Turnover</li>
        <li>Return on Equity</li>
        <li>Growth in Operating Profits</li>
        <li>Growth in Turnover</li>
        <li>Net Tangible Assets</li>
        <li>Operating Cash Flow as a percentage of OPBT</li>
        <li>Quick Ratio</li>
        <li>Debt to Equity Ratio</li>
        <li>Return on Total Fixed Assets</li>
        <li>Operating Profit per Employee</li>
      </ul>

      <p>
        In addition, qualitative factors including business model, management
        ideals and innovation, internationalisation, knowledge initiatives,
        market branding and presence, risk management and sustainability will be
        taken into consideration in ranking the companies. These qualitative
        factors will not influence the rankings by more than 45%.
      </p>

      <p>
        To maintain confidentiality, the profit figures of individual companies
        will NOT be publicly released. Individual operating profit figures will
        only be used for the purpose of ranking and will be published only as a
        percentage or ratio - for example, percentage growth in operating
        profits over three years. However, profit and other figures may be used
        for research purposes.
      </p>

      <p>
        The organiser&apos;s decisions on all aspects of this initiative
        including ranking, evaluation and publication of the list will be final.
      </p>

      <p>
        <strong>Benefits</strong>
      </p>

      <p>
        E50 companies are an elite group, having the privilege of using the E50
        logo on their corporate collaterals – this sets them apart as the cream
        of Singapore&apos;s business crop. Being an E50 company is a valuable
        mark of recognition for any local company.
      </p>

      <p>
        Since its inception, the E50 Awards have honoured more than 600
        companies, from which more than 100 have gone on to be listed on both
        local and overseas stock markets. The Awards are regarded by many local
        enterprises as a stepping stone towards a public listing, and are a
        sought-after stamp recognising excellence.
      </p>

      <p>
        Extensive media coverage is also provided, giving these companies due
        recognition and publicity support. With a heightened public profile,
        these enterprises can expect to enjoy greater business opportunities.
      </p>

      <p>
        The Business Times, The Straits Times and Lianhe Zaobao also produce a
        special E50 supplement in conjunction with the E50 Gala Dinner, where
        the yearly E50 companies are announced. The gala dinner is typically
        held in the fourth quarter of the year.
      </p>

      <p>
        Subsequently, The Business Times will profile the E50 companies over the
        course of the year.
      </p>
    </div>
  );
};
export default E50AwardsPage;
